import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";
import { useCallback, useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { getOrganization } from "../../../setup/api/services/organization";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import { useKcToken } from "../../../setup/auth/useKcToken";
import { useOrganizationCode } from "../../../setup/util/extractOrganizationCode";
import { IOrganizations } from "../../../setup/types/Organisation";
import BasicInformation from "./components/BasicInformation";
import BankInformation from "./components/BankInformation";
import DocumentationInformation from "./components/DocumentationInformation";
import TiersInformation from "./components/TiersInformation";
import UsersInformation from "./components/UsersInformation";

const BusinessSettings = () => {
  const { t } = useTranslation();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const userToken = useKcToken();
  const [organization, setOrganization] = useState<IOrganizations | undefined>(
    undefined
  );

  const organizationCode = useOrganizationCode(userToken);

  const fetchOrganization = useCallback(async () => {
    if (!organizationCode) return;
    const response = await getOrganization(
      organizationCode as unknown as string
    );
    setOrganization(response.data);
  }, [organizationCode]);

  useEffect(() => {
    if (organizationCode) {
      fetchOrganization();
    }
  }, [fetchOrganization, organizationCode]);

  const list = useMemo(() => {
    return [
      {
        id: 0,
        title: "البيانات الأساسية",
      },
      {
        id: 1,

        title: "إدارة المستخدمين",
      },
      {
        id: 2,
        title: "بيانات الحساب البنكي",
      },
      {
        id: 3,
        title: "الملفات والتوثيق",
      },
      {
        id: 4,
        title: "اتفاقية وفّي",
      },
    ];
  }, []);

  return (
    <div className={styles.container}>
      <h1 className={styles.topHeader}>{t("lbl_settings")}</h1>
      <div className={styles.tabContainer}>
        {list?.map((listItem) => (
          <li
            onClick={() => setSelectedIndex(listItem?.id)}
            key={listItem?.title}
            className={classNames(
              styles.listItem,
              {
                [styles.listItemSelected]: listItem?.id === selectedIndex,
              },
              { [styles.firstItem]: listItem?.id === 0 },
              {
                [styles.lastItem]:
                  listItem?.id === list?.[list?.length - 1]?.id,
              }
            )}>
            {listItem?.title}
          </li>
        ))}
      </div>
      {selectedIndex === 0 && <BasicInformation organization={organization} />}
      {selectedIndex === 1 && <UsersInformation organization={organization} />}
      {selectedIndex === 2 && <BankInformation organization={organization} />}
      {selectedIndex === 3 && (
        <DocumentationInformation organization={organization} />
      )}
      {selectedIndex === 4 && <TiersInformation organization={organization} />}
    </div>
  );
};

export default BusinessSettings;
